import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromState from './error.state';

export const selectErrorsState = createFeatureSelector<fromState.ErrorState>(fromState.featureKey);

export const selectError = createSelector(selectErrorsState, state => {
  return state.errors;
});
